import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { useI18n } from 'i18n/hooks/useI18n';

type Props = {
  onClick: () => void;
  disabled: boolean;
};

export function UseAddressButton({ onClick, disabled }: Props) {
  const { i18n } = useI18n();

  return (
    <Box mb={32}>
      <Button
        type="button"
        variant="secondary"
        qaId="use-org-address"
        disabled={disabled}
        onClick={onClick}
      >
        <Box display="flex" alignItems="center">
          <Icon name="list" size={18} />
          <Box ml="8px">{i18n('Autofill Organization Address')}</Box>
        </Box>
      </Button>
    </Box>
  );
}
